<template>
  <div>
    <div class="container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="local-device">
          <div class="handle-box">
            <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" @visible-change="visibleChange"
              @change="clearRoom" collapse-tags clearable filterable></el-cascader>
            <el-select v-model="query.room_id" clearable placeholder="房间" class="handle-select mr5">
              <el-option v-for="item in searchRooms" :key="item.value" :label="item.label"
                :value="Number(item.value)"></el-option>
            </el-select>
            <el-select v-model="query.type" clearable placeholder="设备类型" class="handle-select mr5">
              <el-option v-for="item in fromOptions" :key="item.value" :label="item.label"
                :value="Number(item.value)" @click="getFromOptions(item.from)"></el-option>
            </el-select>
            <el-select v-model="query.from" clearable placeholder="来源" class="handle-select mr5">
              <el-option v-for="item in fromList" :key="item.value" :label="item.label"
                :value="Number(item.value)"></el-option>
            </el-select>
            <el-input v-model="query.name" placeholder="设备名" class="handle-input mr5"></el-input>
            <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr5"></el-input>
            <el-select v-model="query.is_validate" clearable placeholder="有效" class="mr5" style="width: 100px;">
              <el-option key="1" label="是" value="1"></el-option>
              <el-option key="2" label="否" value="0"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="addDevice">添加</el-button>
          </div>
          <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
            :cell-style="centerStyle">
            <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
            <el-table-column prop="name" label="设备名" width="200" show-overflow-tooltip
              header-align="center"></el-table-column>
            <el-table-column prop="code" label="编码" header-align="center" width="250">
              <template #default="scope">
                <el-button type="text" :style="'color:#409EFF'" @click="showDetail(scope.row.id)">
                  {{ scope.row.code }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="control" label="控制位" width="75"></el-table-column>
            <el-table-column prop="store_name" label="门店" show-overflow-tooltip header-align="center"></el-table-column>
            <el-table-column prop="room_name" label="房间" show-overflow-tooltip header-align="center"></el-table-column>
            <el-table-column prop="delay" label="延时" header-align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center" width="120">
              <template #default="scope">
                <span>{{ typeMap.get(scope.row.type) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否有效" width="100" align="center">
              <template #default="scope">
                <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
                  @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
                  {{ scope.row.is_validate ? "有效" : "无效" }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240" align="center">
              <template #default="scope">
                <el-button type="text" icon="el-icon-edit" @click="editDevice(scope.row)">编辑
                </el-button>
                <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.id)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
              :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="item.label" :name="item.value + ''" v-for="item in fromOptions" :key="item.value"
          label-width="100px">
          <template v-if="item.value === DEVICE_TYPE.DEVICE_PIA.value">
            <PiaDeviceTable :ref="item.value + ''" :device-type="item.type" :device-value="item.value"
              :device-allow="item.allow" :device-contorl="item.control"></PiaDeviceTable>
          </template>
          <template v-else>
            <DeviceType :ref="item.value + ''" :device-type="item.label" :device-value="item.value"
              :device-allow="item.allow" :device-contorl="item.control" :device-from="item.from"></DeviceType>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog v-model="dialogVisible" :title="[form.code ? '编辑' : '添加'] + '设备'" @close="dialogVisible = false" :width="550">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item prop="name" label="名称：">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item prop="code" label="编码：">
          <el-input v-model="form.code" placeholder="请输入编码"></el-input>
        </el-form-item>
        <el-form-item label="控制位：">
          <el-input-number v-model="form.control" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="延时：" v-if="form.type === 1 || form.type === 2">
          <el-input-number v-model="form.delay" :controls="false" min="-1800" max="1800"></el-input-number>
          <span class="tip">(单位：秒，-1为不自动执行)</span>
        </el-form-item>
        <el-form-item prop="store_id" label="门店：">
          <el-select v-model.number="form.store_id" clearable @clear="clearRoom">
            <el-option v-for="item in allStoreOptions" :key="item.value" :label="item.label" :value="Number(item.value)"
              @click="getRoomOption(form.store_id)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间：" v-show="notPia">
          <el-select v-model.number="form.room_id" clearable>
            <el-option v-for="item in roomOptions" :key="item.value" :label="item.label || ''"
              :value="Number(item.value)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型：" prop="type">
          <el-select v-model="form.type" clearable>
            <el-option @click="determineType(item)" v-for="item in fromOptions" :key="item.value" :label="item.label"
              :value="Number(item.value)"  ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备来源：" prop="from">
          <el-select v-model="form.from" clearable>
            <el-option v-for="item in fromList" :key="item.value" :label="item.label"
              :value="Number(item.value)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="is_validate" label="是否有效：">
          <el-switch v-model="form.is_validate"></el-switch>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveDeviceSubmit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog v-model="commandVisible" :title="[form.code ? '编辑' : '添加'] + '命令'" @close="commandVisible = false">
      <el-form ref="form" :model="command" :rules="commandRules" label-width="100px">
        <el-form-item prop="name" label="名称：">
          <el-input v-model="command.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item prop="value" label="指令：">
          <el-input :autosize="{ minRows: 5 }" type="textarea" v-model.json="command.value"
            placeholder="请输入指令"></el-input>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button @click="commandVisible = false">取消</el-button>
          <el-button type="primary" @click="addCommandSubmit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="设备详情" v-model="detailVisible" width="30%">
      <div class="rowstyle">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">设备名</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">设备编码</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.code }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">控制位</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.control }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="detailData.type === 1 || detailData.type === 2">
          <el-col :span="6">
            <div class="grid-content bg-purple">延时</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.delay }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">门店</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.store_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">房间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.room_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">设备类型</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ typeMap.get(detailData.type) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">设备来源</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ fromMap.get(detailData.from) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">是否有效</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.is_validate ? '有效' : '无效' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">添加时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(detailData.c_at) }}</div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addCommand } from "@/api/command";
import moment from "moment";
import PiaDeviceTable from "@/views/PiaDeviceTable.vue";
import DeviceType from "@/views/DeviceType.vue";
import {
  deleteDevice,
  getDeviceList,
  setDeviceIsvalidate,
  getDeviceFrom,
  getDeviceType,
  saveTYDevice
} from "@/api/device";
import { getRoomOption } from '@/api/room';
import { getAreaOption, getStoreOption } from "@/api/store";
import { DEVICE_TYPE } from "@/constant/device"

export default {
  name: "DeviceTable",
  components: { PiaDeviceTable, DeviceType },
  computed: {
    DEVICE_TYPE() {
      return DEVICE_TYPE
    }
  },
  data() {
    return {
      activeName: 'local-device',
      query: {
        name: "",
        code: "",
        from: null,
        is_validate: null,
        page: 1,
        page_size: 10
      },
      tableData: [],
      authList: [],
      checkAuthList: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      authVisible: false,
      pageTotal: 0,
      password: "",
      idx: -1,
      id: -1,
      dialogVisible: false,
      form: {
        id: 0,
        name: '',
        code: '',
        control: 0,
        is_validate: true,
        room_id: null,
        delay: 0,
        from: null,
        type: null
      },
      command: {
        id: null,
        device_id: null,
        name: null,
        value: null,
      },
      commandVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        store_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
        from: [{ required: true, message: '请选择设备来源', trigger: 'change' }],
        type: [{ required: true, message: '请选择设备类型', trigger: 'change' }]
      },
      commandRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        value: [{ required: true, message: '请输入指令', trigger: 'blur' }],
      },
      storeOptions: [],  // 门店
      roomOptions: [], // 房间
      searchRooms: [],//搜索时的房间
      fromOptions: [], // 来源
      typeOptions: [], // 类型
      fromMap: new Map(),
      typeMap: new Map(),
      typeList: [],
      detailVisible: false,
      detailData: {},
      areaOptions: [],
      area_store: [],
      props: {},
      notPia: true,
      allStoreOptions: [],
      fromList:[]
    };
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getCompant()
      this.getAreaOptions()
      this.getData();
      this.getStoreOption(0)
      this.getDeviceFromOption()
      this.getDeviceTypeOption()
      this.getAllStoreOption()
    },

    getCompant() {
      this.props = {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    },

    determineType(item) {
      if(item){
        this.fromList = item.from
      }
      if ((item ? item.value : this.form.type) === 6) {
        this.notPia = false
        this.form.room_id = null
      } else {
        this.notPia = true
      }
    },

    centerStyle() {
      return 'text-align:center'
    },

    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },

    // eslint-disable-next-line no-unused-vars
    handleClick(tab, event) {
      if (this.$refs[tab.paneName]) {
        this.$nextTick(() => {
          this.$refs[tab.paneName].init()
        })
      }
    },

    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },

    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    visibleChange(val) {
      setTimeout(() => {
        if (!val && this.area_store != null && this.area_store.length > 1) {
          this.query.store_id = this.area_store[1]
          this.getRoomOption(this.query.store_id)
        }
      }, 200)

    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },

    // 获取 easy-mock 的模拟数据
    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      getDeviceList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },

    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteDevice(id).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    setIsvalidate(index, id, isvalidate) {
      setDeviceIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    editDevice(row) {
      this.form = JSON.parse(JSON.stringify(row))
      // this.$refs.form && this.$refs.form.resetFields()
      this.form.code = row.code
      this.form.name = row.name
      this.form.control = row.control || 0
      this.form.is_validate = row.is_validate
      this.form.room_id = row.room_id || 0
      this.form.store_id = row.store_id || 0
      this.form.from = row.from
      this.form.type = row.type || 0
      this.form.id = row.id
      this.getRoomOption(this.form.store_id)
      this.getDeviceTypeOption()
      this.determineType(null)
      this.dialogVisible = true
    },

    addDevice() {
      this.form = {}
      this.form.id = 0
      this.form.store_id = 0
      this.form.room_id = null
      this.dialogVisible = true
      this.notPia = true
      this.getRoomOption(this.form.store_id)
    },

    saveDeviceSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        saveTYDevice(this.form).then(() => {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.getData()
        })
      })
    },

    editAddCommand(row) {
      this.command = {}
      this.command.device_id = row.id
      this.commandVisible = true
    },

    addCommandSubmit() {
      addCommand(this.command).then(res => {
        if (res === true) {
          this.$message.success('添加成功')
          this.commandVisible = false
        }
      })
    },

    //获取门店信息
    getStoreOption(id) {
      this.storeOptions = [{ value: 0, label: '平台' }]
      getStoreOption(id).then(res => {
        res.forEach(function (val) {
          this.storeOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },
    getAllStoreOption() {
      this.allStoreOptions = [{ value: 0, label: '平台' }]
      getStoreOption().then(res => {
        res.forEach(function (val) {
          this.allStoreOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },


    // 获取房间信息
    getRoomOption(id) {
      this.query.room_id = null
      getRoomOption(id).then(res => {
        this.roomOptions = []
        this.searchRooms = []
        let that = this
        res.forEach(function (item) {
          that.roomOptions.push(item)
          if (id === that.query.store_id) {
            that.searchRooms = JSON.parse(JSON.stringify(that.roomOptions))
          }
        })
      })
    },

    clearRoom() {
      this.query.room_id = null
      this.form.room_id = null
      this.roomOptions = []
      this.searchRooms = []
    },

    getDeviceFromOption() {
      getDeviceFrom().then(res => {
        let that = this
        res.forEach(function (item) {
          item.allow = item.value != 4 && item.value != 2 ? true : false
          item.control = item.value == 6 ? true : false
          that.fromMap.set(item.value, item.label)
        })
        this.fromOptions = res
      })
    },

    getDeviceTypeOption() {
      getDeviceType().then(res => {
        let that = this
        res.forEach(function (item) {
          that.typeMap.set(item.value, item.label)
        })
        this.typeOptions = res
      })
    },

    //设备详情
    showDetail(id) {
      this.tableData.forEach(item => {
        this.fromMap.set(item.value, item.label)
        if (item.id === id) {
          this.detailData = JSON.parse(JSON.stringify(item))
        }
      })
      this.detailVisible = true
    },
    getFromOptions(from){
      this.fromList = from
    }
  }
};
</script>

<style scoped>
.handle-input {
  width: 200px;
  display: inline-block;
  margin-right: 10px;
}

.handle-box {
  margin-bottom: 10px;
}

.mr5 {
  margin-right: 5px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: red;
}

.el-select {
  margin-bottom: 10px;
}


.rowstyle {
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip {
  font-size: 12px;
  color: red;
}

/deep/ .el-tabs__item {
  width: 100px;
  text-align: center;
}

/deep/.el-cascader {
  width: 300px;
  margin-right: 5px;
}
</style>
